import React from "react";
import {connect} from "react-redux";
import {styled} from "@reside/ui";

import {select, AppState} from "../../store";
import {Layout, LayoutContent} from "../../atoms/admin-layout";
import {AdminNavigationHeader} from "../../atoms/admin-navigation-header";
import {Copyright} from "../../atoms/copyright";
import {DocumentTitle} from "../../atoms/document-title";
import {UserDetail} from "../../store/users/usersModel";
import {Facilities} from "../../models/types/AdmissionForm";
import {PageBody} from "./PageAdminFacilitySettingsBody";

type Props = Readonly<{
  user: UserDetail;
  facilities: Facilities;
}>;

export const PageAdminFacilitySettingsRenderer = ({
  user,
  facilities,
}: Props) => {
  return (
    <>
      <DocumentTitle title="Reside - Admin - Facility Settings" />
      <FacilitySettingsLayout>
        <AdminNavigationHeader />
        <FacilitySettingsContent>
          <PageBody user={user} facilities={facilities} />
        </FacilitySettingsContent>
        <Copyright />
      </FacilitySettingsLayout>
    </>
  );
};

/** Mirrors WideLayout from ReportingLayout — locks the page to viewport height. */
const FacilitySettingsLayout = styled(Layout)`
  min-height: 100vh;
  max-height: 100vh;
`;

/** Mirrors WideLayoutContent — fills remaining height, full-width, clips overflow. */
const FacilitySettingsContent = styled(LayoutContent)`
  flex-grow: 1;
  overflow: hidden;
  max-width: none;
  padding: 20px 32px 0;
`;

const mapStateToProps = (state: AppState) => ({
  user: select.adminSession.user(state),
  facilities: select.adminSession.facilities(state),
});

export const PageAdminFacilitySettings = connect(mapStateToProps)(
  PageAdminFacilitySettingsRenderer,
);
